import Context from './Context.js';

export default class Referrer extends Context {
  constructor(host, category) {
    super();
    this.data = {
      re_ho: host,
      re_ca: category
    };
  }

  static get key() {
    return 'referer_event_context'
  }

  static get PPC() {
    return 'ppc';
  }
  static get SEO() {
    return 'seo';
  }
  static get SOCIAL() {
    return 'social';
  }

  hasReferrerChanged(host) {
    return this.data.re_ho !== host;
  }
}
